import * as R from 'ramda';
import { AreaIcon } from '../../components/results-view/assets/icons';
import { AggregationFunction, ApexChartType, ApexChartXAxisValidValues } from '../../constants';
import { Chart } from './chart';

export class Area extends Chart {
    protected chartType: ApexChartType = ApexChartType.Area;

    protected description = 'Area graphs can be used to show how data change over time';

    protected icon: any = AreaIcon;

    protected xAxisTypes = {
        numeric: ApexChartXAxisValidValues.numeric,
        datetime: ApexChartXAxisValidValues.datetime,
    };

    protected aggregationFunctions: AggregationFunction[] = [
        AggregationFunction.AVG,
        AggregationFunction.COUNT,
        AggregationFunction.SUM,
    ];

    configuration(title: string): any {
        const chart = { ...Chart.defaultChartOption.chart, ...Chart.defaultChartSelection };
        return R.clone({
            ...Chart.defaultConfiguration(R.isNil(title) ? 'Title' : title, this.description),
            ...Chart.defaultLegend,
            ...Chart.defaultStroke,
            ...Chart.defaultXAxis,
            ...Chart.defaultYAxis,
            ...Chart.defaultGrid,
            ...Chart.defaultMarkers,
            ...Chart.defaultDataLabels,
            chart,
        });
    }
}

Chart.register(new Area());
